module.exports = __webpack_public_path__ + "img/paper-clip.549c86b7.svg";